import { useParams } from "react-router-dom";
import { LoadingSpinner } from "../../../components/ui/LoadingSpinner";
import { useGameFormState } from "../shared/useGameFormState";
import EditGameForm from "./EditGameForm";

const EditGame = () => {
  const { gameId } = useParams();
  const state = useGameFormState({ isEdit: true, gameId });

  if (state.isFetching) {
    return <LoadingSpinner />;
  }

  return <EditGameForm {...state} />;
};

export default EditGame;
